<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
  v-card
    div.mx-auto.py-6(style="width: 400px")
      .text-xl.font-semibold.text-center
        div Thank you for your interest in our
        div {{ featureName }} feature! 😊
    v-card.round-lg.pa-4.mx-6.card(outlined)
      .d-flex.align-start
        .text-md.mr-3 🧑‍💻
        .text-md
          div Let us know you are interested in this feature and we will set up a demo session accordingly.
          div Press submit to confirm
    v-divider.mt-6
    v-card-actions.px-6
      v-spacer
      v-btn.button-md.neutral700--text.px-0.mr-2(text @click="closeDialog") {{ $t('cancel') }}
      v-btn.button-md(:loading="loading" color="neutral700" depressed dark @click="handleSubmit") {{ $t('submit') }}
</template>

<script>

export default {
  props: {
    open: {
      type: Boolean,
    },
    featureName: {
      type: String,
      default: 'connect to checkout'
    },
    loading: {
      type: Boolean,
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('cancel')
      this.showDialog = false
    },
    handleSubmit() {
      this.$emit('submit')
    }
  },
}
</script>

<style scoped>
.card {
  border: 1px solid #EEEEEE !important;
  background-color: #F9FAFB !important;
}
</style>